var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCircleFilledSmall = function SvgCircleFilledSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "circle-filled-small"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11 10.2679C11.3789 10.0492 11.8191 9.96072 12.2531 10.0161C12.687 10.0714 13.0909 10.2676 13.4027 10.5744C13.7146 10.8813 13.9172 11.2819 13.9796 11.7149C14.0419 12.148 13.9606 12.5895 13.748 12.9719C13.5354 13.3542 13.2033 13.6563 12.8026 13.8319C12.4018 14.0075 11.9546 14.0468 11.5294 13.9438C11.1041 13.8409 10.7244 13.6014 10.4484 13.262C10.1723 12.9226 10.0152 12.502 10.001 12.0647L10 11.9999L10.001 11.9351C10.012 11.5952 10.1096 11.2637 10.2844 10.972C10.4592 10.6803 10.7055 10.438 11 10.2679Z"
  }))));
};
export default SvgCircleFilledSmall;